import { render, staticRenderFns } from "./CreateMailingList.vue?vue&type=template&id=6116a2ae&"
import script from "./CreateMailingList.vue?vue&type=script&lang=js&"
export * from "./CreateMailingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports